import {DARK_GREEN, GREY, RED, YELLOW} from '../../../../BerendsohnMUITheme';

export const STATUS_COLORS: Record<string, string> = {
    match: DARK_GREEN,
    uncertain: YELLOW,
    new: GREY,
    error: RED,
};

export const STATUS_LABELS: Record<string, string> = {
    match: 'Treffer',
    uncertain: 'Unsicher',
    new: 'Neu',
    error: 'Fehler',
};

export const FIELD_LABELS: Record<string, string> = {
    companyName: 'Firmenname',
    phone: 'Telefon',
    website: 'Website',
    address: 'Adresse',
    street: 'Straße',
    houseNumber: 'Hausnummer',
    zipCode: 'PLZ',
    city: 'Ort',
    geo: 'Geo',
};

export const SKIPPED_LABELS: Record<string, string> = {
    skipped_no_input: 'Nicht eingegeben',
    skipped_no_candidate_value: 'Kein Wert beim Kandidaten',
    skipped_normalization_empty: 'Normalisierung leer',
};

export const ADDRESS_FIELDS = new Set(['street', 'houseNumber', 'zipCode', 'city', 'geo']);

export const WEIGHT_FIELDS: {key: string; label: string; defaultPct: number}[] = [
    {key: 'companyName', label: 'Firmenname', defaultPct: 25},
    {key: 'website',     label: 'Website',    defaultPct: 20},
    {key: 'phone',       label: 'Telefon',    defaultPct: 15},
    {key: 'street',      label: 'Straße',     defaultPct: 12},
    {key: 'geo',         label: 'Geo',        defaultPct: 10},
    {key: 'zipCode',     label: 'PLZ',        defaultPct: 8},
    {key: 'city',        label: 'Ort',        defaultPct: 5},
    {key: 'houseNumber', label: 'Hausnummer', defaultPct: 5},
];

export const WEIGHT_DEFAULTS_PCT: Record<string, number> = Object.fromEntries(
    WEIGHT_FIELDS.map((f) => [f.key, f.defaultPct]),
);

export const LLM_VERDICT_LABELS: Record<string, string> = {
    duplicate: 'Dublette',
    not_duplicate: 'Keine Dublette',
    uncertain: 'Unsicher',
};

export const LLM_VERDICT_COLORS: Record<string, string> = {
    duplicate: DARK_GREEN,
    not_duplicate: GREY,
    uncertain: YELLOW,
};

export const LLM_PATTERN_LABELS: Record<string, string> = {
    identical: 'Identisch',
    successor: 'Nachfolger',
    relocation: 'Umzug',
    branch: 'Filiale',
    brand_vs_entity: 'Marke / Rechtsträger',
    shared_address: 'Gleiche Adresse',
    namesake: 'Namensgleich',
    unrelated: 'Kein Zusammenhang',
};

export const LLM_STORAGE_KEY = 'duplicateCheck.llm';

export const DEFAULT_MAX_TOP_N = 20;
export const INTER_REQUEST_DELAY_MS = 150;
export const RATE_LIMIT_BACKOFF_MS = 3000;
export const MAX_RATE_LIMIT_RETRIES = 5;

// muss zu LLM_MAX_CANDIDATES im Backend passen
export const LLM_MAX_CANDIDATES = 5;
